function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo, useState } from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext, AccordionContext } from "../index";
import Loader from "./../Loader/Loader";
import Select from "react-select";
import { HiDownload } from "react-icons/hi";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import "./ManagePermission.css";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { VscLoading } from "react-icons/vsc";
// import {
//   LEAVE_DETAILS_FOR_STATUS_QUERY,
//   LEAVE_DETAILS_FOR_STATUS_COUNT_QUERY,
//   UPDATE_LEAVE_STATUS_MUTATION,
//   LEAVE_DETAILS_FOR_STATUS_EXPORT_QUERY,
// } from "./query";
import { GET_USER_LISTING_QUERY } from "./../MonthlyAttendance/query";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { stringToArrayOutput } from "./../SideMenu/Header";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
// import { DELETE_LEAVE_DETAILS_MUTATION } from "./../ViewLeave/query";
// import { LEAVE_SETTINGS_APPROVED_LIST_QUERY } from "./../LeaveSettings/query";
import { convertOrganisationTimezones } from "./../ViewLeave/ViewLeave";
import ControlLabel from "react-bootstrap/FormLabel";
import { Form } from "react-bootstrap";
var LIMIT = 10;
var offsets = 0;
var ManagePermission = function ManagePermission(props) {
  var _userListData$getUser;
  var _React$useState = React.useState("pending"),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    tabData = _React$useState2[0],
    setTabData = _React$useState2[1];
  var _React$useState3 = React.useState({
      label: "All Employees",
      value: ""
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    userParameterCheck = _React$useState4[0],
    setUserParameterCheck = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    startDate = _React$useState6[0],
    setStartDate = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    exportButton = _React$useState8[0],
    setExportButton = _React$useState8[1];
  var _React$useState9 = React.useState([]),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    reviewedLeaveList = _React$useState10[0],
    setReviewedLeaveList = _React$useState10[1];
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    leaveSettingsUser = _React$useContext.leaveSettingsUser;
  var _React$useState11 = React.useState(stringToArrayOutput("Free Plan Days", organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone)),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    last14Days = _React$useState12[0],
    setLast14Days = _React$useState12[1];
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var leaveSettingsCheckForUser = leaveSettingsUser && leaveSettingsUser !== null && leaveSettingsUser !== void 0 && leaveSettingsUser.approvedList.length ? leaveSettingsUser === null || leaveSettingsUser === void 0 ? void 0 : leaveSettingsUser.approvedList.find(function (o) {
    return o.userId === user.userId;
  }) : null;
  React.useEffect(function () {
    if (from == "web" && (role == "Member" || role == "Head") && !leaveSettingsCheckForUser && role != "Admin") {
      if (role == "Head") {
        props === null || props === void 0 ? void 0 : props.history.push("/overview");
      }
      if (role == "Member") {
        props === null || props === void 0 ? void 0 : props.history.push("/my-work");
      }
    }
  }, [role, leaveSettingsCheckForUser]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" && role != "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var userList = [{
    label: "All Employees",
    value: null
  }];
  var _useQuery = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    userListLoading = _useQuery.loading,
    userListData = _useQuery.data,
    userListError = _useQuery.error;
  userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser = userListData.getUserListing) === null || _userListData$getUser === void 0 ? void 0 : _userListData$getUser.map(function (item) {
    var userId = item.userId,
      displayName = item.displayName;
    return userList.push({
      label: displayName,
      value: userId
    });
  });
  var handleTabSelect = function handleTabSelect(key) {
    setTabData(key);
    offsets = 0;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-listing-tab-whole-div"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "pending",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    },
    className: "admin-view-leave-root-tab"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "pending",
    title: /*#__PURE__*/React.createElement("span", null, "Approval Pending Permission (2)", " ")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userList,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling
    // userListLoading={userListLoading}
    ,
    exportButton: exportButton,
    setExportButton: setExportButton,
    tabData: tabData,
    organisationId: organisationId,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName
  }), /*#__PURE__*/React.createElement(TabData, {
    tabData: tabData,
    userParameterCheck: userParameterCheck,
    leavePeriodDate: startDate,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationId: organisationId,
    reviewedLeaveList: reviewedLeaveList,
    setReviewedLeaveList: setReviewedLeaveList,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationBilling: organisationBilling
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "approved",
    title: /*#__PURE__*/React.createElement("span", null, "Approved Permission", " ")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userList,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling
    // userListLoading={userListLoading}
    ,
    exportButton: exportButton,
    setExportButton: setExportButton,
    tabData: tabData,
    organisationId: organisationId,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName
  }), /*#__PURE__*/React.createElement(TabData, {
    tabData: tabData,
    userParameterCheck: userParameterCheck,
    leavePeriodDate: startDate,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationId: organisationId,
    reviewedLeaveList: reviewedLeaveList,
    setReviewedLeaveList: setReviewedLeaveList,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationBilling: organisationBilling
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "rejected",
    title: /*#__PURE__*/React.createElement("span", null, "Rejected Permission", " ")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userList,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling
    // userListLoading={userListLoading}
    ,
    exportButton: exportButton,
    setExportButton: setExportButton,
    tabData: tabData,
    organisationId: organisationId,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName
  }), /*#__PURE__*/React.createElement(TabData, {
    tabData: tabData,
    userParameterCheck: userParameterCheck,
    leavePeriodDate: startDate,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationId: organisationId,
    reviewedLeaveList: reviewedLeaveList,
    setReviewedLeaveList: setReviewedLeaveList,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationBilling: organisationBilling
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "all",
    title: /*#__PURE__*/React.createElement("span", null, "All Permission", " ")
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userListData: userList,
    setStartDate: setStartDate,
    startDate: startDate,
    organisationBilling: organisationBilling
    // userListLoading={userListLoading}
    ,
    exportButton: exportButton,
    setExportButton: setExportButton,
    tabData: tabData,
    organisationId: organisationId,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName
  }), /*#__PURE__*/React.createElement(TabData, {
    tabData: tabData,
    userParameterCheck: userParameterCheck,
    leavePeriodDate: startDate,
    organisationTimezone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    organisationId: organisationId,
    reviewedLeaveList: reviewedLeaveList,
    setReviewedLeaveList: setReviewedLeaveList,
    last14Days: last14Days,
    planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName,
    organisationBilling: organisationBilling
  })))))));
};
var TabFilter = function TabFilter(props) {
  var userParameterCheck = props.userParameterCheck,
    setUserParameterCheck = props.setUserParameterCheck,
    userListData = props.userListData,
    setStartDate = props.setStartDate,
    startDate = props.startDate,
    organisationBilling = props.organisationBilling,
    userListLoading = props.userListLoading,
    exportButton = props.exportButton,
    setExportButton = props.setExportButton,
    tabData = props.tabData,
    organisationId = props.organisationId,
    organisationTimezone = props.organisationTimezone,
    last14Days = props.last14Days,
    planName = props.planName;

  //   const [getLeaveDetailExport, { loading: leaveExportLoading, data: leaveExportData }] = useLazyQuery(
  //     LEAVE_DETAILS_FOR_STATUS_EXPORT_QUERY
  //   );

  //   const getExportData = async () => {
  //     setExportButton(true);

  //     getLeaveDetailExport({
  //       variables: {
  //         organisationId,
  //         leaveStatus: tabData,
  //         userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
  //         leavePeriod: startDate ? moment(startDate).format("x") : null,
  //         timeZone: organisationTimezone,
  //         freePlanStartDate: planName == "free" ? (last14Days ? last14Days[0] : null) : null,
  //         freePlanEndDate: planName == "free" ? (last14Days ? last14Days[1] : null) : null,
  //       },
  //     });
  //   };

  //   const csvLeaveData = React.useCallback(
  //     async (leavePeriodDate) => {
  //       const dataArray = [];
  //       const dataValues = leaveExportData?.leaveDetailsForStatusExport;

  //       if (!dataValues) {
  //         return [];
  //       }

  //       const wb = new Excel.Workbook();

  //       const ws = wb.addWorksheet();
  //       if (tabData == "all") {
  //         ws.columns = [
  //           {
  //             header: "Employee Name",
  //             key: "user",
  //             width: 20,
  //             style: { alignment: { vertical: "middle", horizontal: "left" } },
  //           },
  //           {
  //             header: "Leave Period",
  //             key: "leavePeriod",
  //             width: 10,
  //             style: { alignment: { vertical: "middle", horizontal: "left" } },
  //           },

  //           { header: "Days", key: "days", style: { alignment: { vertical: "middle", horizontal: "left" } } },
  //           { header: "Type", key: "type", style: { alignment: { vertical: "middle", horizontal: "left" } } },
  //           {
  //             header: "Applied On",
  //             key: "appliedOn",
  //             style: { alignment: { vertical: "middle", horizontal: "left" } },
  //           },
  //           {
  //             header: "Status",
  //             key: "status",
  //             style: { alignment: { vertical: "middle", horizontal: "left" } },
  //           },
  //           {
  //             header: "Leave Reason",
  //             key: "leaveReason",
  //             style: { alignment: { vertical: "middle", horizontal: "left" } },
  //           },
  //         ];
  //       } else {
  //         ws.columns = [
  //           {
  //             header: "Employee Name",
  //             key: "user",
  //             width: 20,
  //             style: { alignment: { vertical: "middle", horizontal: "left" } },
  //           },
  //           {
  //             header: "Leave Period",
  //             key: "leavePeriod",
  //             width: 10,
  //             style: { alignment: { vertical: "middle", horizontal: "left" } },
  //           },

  //           { header: "Days", key: "days", style: { alignment: { vertical: "middle", horizontal: "left" } } },
  //           { header: "Type", key: "type", style: { alignment: { vertical: "middle", horizontal: "left" } } },
  //           {
  //             header: "Applied On",
  //             key: "appliedOn",
  //             style: { alignment: { vertical: "middle", horizontal: "left" } },
  //           },

  //           {
  //             header: "Leave Reason",
  //             key: "leaveReason",
  //             style: { alignment: { vertical: "middle", horizontal: "left" } },
  //           },
  //         ];
  //       }

  //       dataValues.map((d, index) => {
  //         const { leaveType, leaveStartDate, leaveEndDate, leaveDays, leaveReason, appliedAt, user, appliedStatus } = d;
  //         let { displayName } = user;

  //         const leaveDate = leaveEndDate
  //           ? `${moment(leaveStartDate).format("DD MMM YYYY")} - ${moment(leaveEndDate).format("DD MMM YYYY")}`
  //           : moment(leaveStartDate).format("DD MMM YYYY");

  //         const leaveDaysTemp = Number(leaveDays) > 1 ? `${Number(leaveDays)} Days` : `${Number(leaveDays)} Day`;

  //         const applieOnTemp = moment(appliedAt).format("DD MMM YYYY");

  //         ws.addRow({
  //           user: displayName,
  //           leavePeriod: leaveDate,
  //           days: leaveDaysTemp,
  //           type: leaveType,
  //           appliedOn: applieOnTemp,
  //           status: tabData == "all" ? appliedStatus : "",
  //           leaveReason,
  //         });
  //       });

  //       ws.getCell("A1").font = { bold: true };
  //       ws.getCell("B1").font = { bold: true };
  //       ws.getCell("C1").font = { bold: true };
  //       ws.getCell("D1").font = { bold: true };
  //       ws.getCell("E1").font = { bold: true };
  //       ws.getCell("F1").font = { bold: true };

  //       ws.getCell("G1").font = { bold: true };

  //       const buf = await wb.xlsx.writeBuffer();
  //       const fileName = `workfolio-${tabData != "all" ? `${tabData}-` : ""}leave${
  //         leavePeriodDate ? `-${moment(leavePeriodDate).format("DD-MMM")}` : ""
  //       }.xlsx`;
  //       saveAs(new Blob([buf]), fileName);

  //       setExportButton(false);
  //     },
  //     [leaveExportData]
  //   );

  //   React.useEffect(() => {
  //     csvLeaveData(startDate);
  //   }, [leaveExportData]);

  return /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-filter-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-filter-content"
  }, userListLoading ? /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-filter-user-tab-filter"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      return setUserParameterCheck(e);
    },
    options: userListData,
    className: "daily-attendance-filter-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export"))));
};
var leaveDetails = [_defineProperty({
  appliedAt: 1696583664652,
  appliedStatus: "pending",
  dateDetails: [],
  leaveDays: 2,
  leaveEndDate: null,
  leaveId: "be232db0-6428-11ee-b375-f5bd45e803f2",
  leaveReason: "going to temple",
  leaveRejectReason: null,
  leaveStartDate: 1696962600000,
  leaveType: "Demo1",
  statusModifyDisplayName: null,
  user: {
    userId: "509e2f50277576a73a25dbc1926742323d040a2f",
    displayName: "Arun Karthik N",
    profileUrl: "https://workfolio.s3.amazonaws.com/profile_picture/532bd370-e3bc-11eb-8ccc-cb9de24e7007.png",
    uniqueUrl: "mmaqgiXR7QWLyz0jv514Z"
  },
  userId: "509e2f50277576a73a25dbc1926742323d040a2f"
}, "statusModifyDisplayName", "Anitha Sri Rajendran ")];
var TabData = function TabData(props) {
  var tabData = props.tabData,
    userParameterCheck = props.userParameterCheck,
    leavePeriodDate = props.leavePeriodDate,
    organisationTimezone = props.organisationTimezone,
    organisationId = props.organisationId,
    reviewedLeaveList = props.reviewedLeaveList,
    setReviewedLeaveList = props.setReviewedLeaveList,
    last14Days = props.last14Days,
    planName = props.planName,
    organisationBilling = props.organisationBilling;
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isPendingLoaded = _React$useState14[0],
    setIsPendingLoaded = _React$useState14[1];
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isPendingLoadingMore = _React$useState16[0],
    setIsPendingLoadingMore = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isApprovedLoaded = _React$useState18[0],
    setIsApprovedLoaded = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    isApprovedLoadingMore = _React$useState20[0],
    setIsApprovedLoadingMore = _React$useState20[1];
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    isRejectedLoaded = _React$useState22[0],
    setIsRejectedLoaded = _React$useState22[1];
  var _React$useState23 = React.useState(false),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    isRejectedLoadingMore = _React$useState24[0],
    setIsRejectedLoadingMore = _React$useState24[1];
  var _React$useState25 = React.useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    isAllLoaded = _React$useState26[0],
    setIsAllLoaded = _React$useState26[1];
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    isLoadingMore = _React$useState28[0],
    setIsLoadingMore = _React$useState28[1];
  var _React$useState29 = React.useState(null),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    changeLeaveStatusModal = _React$useState30[0],
    setChangeLeaveStatusModal = _React$useState30[1];
  var _React$useState31 = React.useState(null),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    deleteLeaveModal = _React$useState32[0],
    setDeleteLeaveModal = _React$useState32[1];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    deleteLeaveData = _useState2[0],
    setDeleteLeaveData = _useState2[1];
  var _React$useState33 = React.useState(""),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    reasonText = _React$useState34[0],
    setReasonText = _React$useState34[1];
  var handleChangeLeaveStatusClose = function handleChangeLeaveStatusClose() {
    setChangeLeaveStatusModal(false);
    setReasonText("");
  };
  var handleChangeLeaveStatusShow = function handleChangeLeaveStatusShow(list) {
    setChangeLeaveStatusModal(list);
  };
  var handleDeleteLeaveModalClose = function handleDeleteLeaveModalClose() {
    return setDeleteLeaveModal(false);
  };
  var handleDeleteLeaveModalShow = function handleDeleteLeaveModalShow(list) {
    setDeleteLeaveModal(list);
  };

  //   const {
  //     loading: leaveDetailsLoading,
  //     data: leaveDetails,
  //     error: leaveDetailsError,
  //     fetchMore,
  //     refetch: leaveDetailsRefetch,
  //   } = useQuery(LEAVE_DETAILS_FOR_STATUS_QUERY, {
  //     variables: {
  //       organisationId,
  //       leaveStatus: tabData,
  //       userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
  //       leavePeriod: leavePeriodDate ? moment(leavePeriodDate).format("x") : null,
  //       timeZone: organisationTimezone,
  //       limit: LIMIT,
  //       offset: 0,
  //       freePlanStartDate: planName == "free" ? (last14Days ? last14Days[0] : null) : null,
  //       freePlanEndDate: planName == "free" ? (last14Days ? last14Days[1] : null) : null,
  //     },
  //     skip: !organisationId,
  //   });

  //   React.useEffect(() => {
  //     setIsPendingLoaded(false);
  //     setIsAllLoaded(false);
  //     setIsApprovedLoaded(false);
  //     setIsRejectedLoaded(false);

  //     leaveDetailsRefetch?.();
  //   }, [tabData, userParameterCheck, leavePeriodDate]);

  //   React.useEffect(() => {
  //     if (tabData === "pending") {
  //       setIsPendingLoaded(
  //         leaveDetails?.leaveDetailsForStatus?.length != 0 &&
  //           leaveDetails?.leaveDetailsForStatus?.length < LIMIT &&
  //           !isPendingLoaded
  //           ? true
  //           : false
  //       );
  //     } else if (tabData === "all") {
  //       setIsAllLoaded(
  //         leaveDetails?.leaveDetailsForStatus?.length != 0 &&
  //           leaveDetails?.leaveDetailsForStatus?.length < LIMIT &&
  //           !isAllLoaded
  //           ? true
  //           : false
  //       );
  //     } else if (tabData === "approved") {
  //       setIsApprovedLoaded(
  //         leaveDetails?.leaveDetailsForStatus?.length != 0 &&
  //           leaveDetails?.leaveDetailsForStatus?.length < LIMIT &&
  //           !isApprovedLoaded
  //           ? true
  //           : false
  //       );
  //     } else if (tabData === "rejected") {
  //       setIsRejectedLoaded(
  //         leaveDetails?.leaveDetailsForStatus?.length != 0 &&
  //           leaveDetails?.leaveDetailsForStatus?.length < LIMIT &&
  //           !isRejectedLoaded
  //           ? true
  //           : false
  //       );
  //     }
  //   }, [leaveDetails?.leaveDetailsForStatus]);

  //   if (leaveDetailsLoading) {
  //     return <Loader />;
  //   }

  //   if (leaveDetailsError) {
  //     return <div className="common-err-refresh-text">Something went wrong, please refresh the page.</div>;
  //   }

  //   if (!leaveDetails) {
  //     return null;
  //   }

  //   const handleLoadMore = () => {
  //     if (leaveDetailsLoading) return;

  //     if (tabData === "pending") {
  //       setIsPendingLoadingMore(true);
  //     } else if (tabData === "all") {
  //       setIsLoadingMore(true);
  //     } else if (tabData === "approved") {
  //       setIsApprovedLoadingMore(true);
  //     } else if (tabData === "rejected") {
  //       setIsRejectedLoadingMore(true);
  //     }

  //     fetchMore({
  //       variables: {
  //         offset: leaveDetails?.leaveDetailsForStatus?.length,
  //       },

  //       updateQuery: (prev, { fetchMoreResult }) => {
  //         if (!fetchMoreResult) return prev;
  //         if (
  //           fetchMoreResult?.leaveDetailsForStatus.length === 0 &&
  //           fetchMoreResult?.leaveDetailsForStatus.length < LIMIT &&
  //           (!isPendingLoaded || !isAllLoaded || !isApprovedLoaded)
  //         ) {
  //           if (tabData === "pending") {
  //             setIsPendingLoaded(true);
  //           } else if (tabData === "all") {
  //             setIsAllLoaded(true);
  //           } else if (tabData === "approved") {
  //             setIsApprovedLoaded(true);
  //           } else if (tabData === "rejected") {
  //             setIsRejectedLoaded(true);
  //           }
  //         }

  //         if (tabData === "pending") {
  //           setIsPendingLoadingMore(false);
  //         } else if (tabData === "all") {
  //           setIsLoadingMore(false);
  //         } else if (tabData === "approved") {
  //           setIsApprovedLoadingMore(false);
  //         } else if (tabData === "rejected") {
  //           setIsRejectedLoadingMore(false);
  //         }

  //         if (fetchMoreResult?.leaveDetailsForStatus.length > 0) {
  //           const NewFilterData = [];

  //           fetchMoreResult?.leaveDetailsForStatus.forEach((newLeave) => {
  //             const found = prev?.leaveDetailsForStatus.find((item) => item.leaveId === newLeave.leaveId);

  //             if (!found) {
  //               // If not found, add validation.
  //               NewFilterData.push(newLeave);
  //             }
  //           });

  //           return {
  //             ...prev,
  //             leaveDetailsForStatus: [...prev.leaveDetailsForStatus, ...NewFilterData],
  //           };
  //         }
  //       },
  //     });
  //   };

  var currentSystemTimezone = moment.tz.guess();
  var currentSystemOffset = moment.tz(currentSystemTimezone).utcOffset();
  var zoneoffset = moment.tz(organisationTimezone).utcOffset();
  return /*#__PURE__*/React.createElement("div", {
    className: "admin-view-leave-listing-tab-Content"
  }, (leaveDetails === null || leaveDetails === void 0 ? void 0 : leaveDetails.length) !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    responsive: "sm",
    className: "admin-view-leave-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "admin-view-leave-ta-contents-header"
  }, /*#__PURE__*/React.createElement("th", null, "Employee Name"), /*#__PURE__*/React.createElement("th", null, "Date"), /*#__PURE__*/React.createElement("th", null, "Time"), /*#__PURE__*/React.createElement("th", null, "Duration"), /*#__PURE__*/React.createElement("th", null, " Applied On"), tabData == "approved" || tabData == "rejected" ? /*#__PURE__*/React.createElement("th", null, tabData == "approved" ? "Approved by" : "Rejected by") : null, tabData == "all" ? /*#__PURE__*/React.createElement("th", null, "Status") : null, /*#__PURE__*/React.createElement("th", null, "Remark"), tabData == "pending" ? /*#__PURE__*/React.createElement("th", null) : null)), /*#__PURE__*/React.createElement("tbody", {
    className: "admin-view-leave-table-body"
  }, leaveDetails === null || leaveDetails === void 0 ? void 0 : leaveDetails.map(function (list, index) {
    var leaveId = list.leaveId,
      userId = list.userId,
      leaveType = list.leaveType,
      leaveStartDate = list.leaveStartDate,
      leaveEndDate = list.leaveEndDate,
      leaveDays = list.leaveDays,
      leaveReason = list.leaveReason,
      appliedAt = list.appliedAt,
      appliedStatus = list.appliedStatus,
      user = list.user,
      statusModifyDisplayName = list.statusModifyDisplayName,
      leaveRejectReason = list.leaveRejectReason;
    if (tabData == "all" && deleteLeaveData.length > 0 && deleteLeaveData.includes(leaveId)) {
      return;
    }
    var findLeaveStatusDetails = reviewedLeaveList && reviewedLeaveList.find(function (leave) {
      return leave.leaveId === leaveId;
    }) || {};
    var approvedStatusCheck = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId && findLeaveStatusDetails.leaveStatus == "approved" ? true : false;
    var approvedStatusCheckForDisable = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId ? true : false;
    var rejectedStatusCheck = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId && findLeaveStatusDetails.leaveStatus == "rejected" ? true : false;
    var rejectedStatusCheckForDisable = findLeaveStatusDetails && findLeaveStatusDetails.leaveId == leaveId ? true : false;

    /* offset check */

    var startValueFormate = moment.unix(leaveStartDate / 1000).format("DD MMM, yyyy");
    var endValueFormate = leaveEndDate ? moment.unix(leaveEndDate / 1000).format("DD MMM, yyyy") : null;
    if (zoneoffset !== currentSystemOffset) {
      startValueFormate = convertOrganisationTimezones(moment(Number(leaveStartDate)).format("YYYY-MM-DD HH:mm:ss"), 0, organisationTimezone);
      if (leaveEndDate) {
        endValueFormate = convertOrganisationTimezones(moment(Number(leaveEndDate)).format("YYYY-MM-DD HH:mm:ss"), 0, organisationTimezone);
      }
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
      key: index,
      className: "admin-view-leave-listing-tab-Content-list"
    }, /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-displayName"
    }, /*#__PURE__*/React.createElement("div", {
      "class": "admin-view-leave-content-data-details-avatar"
    }, user !== null && user !== void 0 && user.profileUrl ? /*#__PURE__*/React.createElement("div", {
      "class": "employee-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      "class": "admin-view-leave-team-card-avatar-profile-img"
    })) : /*#__PURE__*/React.createElement("div", {
      "class": "admin-view-leave-content-data-details-avatar-circle text-white"
    }, user === null || user === void 0 ? void 0 : user.displayName.charAt(0)), /*#__PURE__*/React.createElement("div", {
      "class": "admin-view-leave-content-data-details-name-data"
    }, /*#__PURE__*/React.createElement("div", {
      "class": "admin-view-leave-content-data-details-name-data-team-name-whole"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, user === null || user === void 0 ? void 0 : user.displayName)
    }, /*#__PURE__*/React.createElement("a", {
      href: "/personal-statistics/".concat(user === null || user === void 0 ? void 0 : user.uniqueUrl)
    }, /*#__PURE__*/React.createElement("span", {
      "class": "admin-view-leave-card-table-list-name"
    }, user === null || user === void 0 ? void 0 : user.displayName))))))), /*#__PURE__*/React.createElement("td", {
      className: "manage-permission-td-date"
    }, leaveEndDate ? "".concat(startValueFormate, " - ").concat(endValueFormate) : startValueFormate), /*#__PURE__*/React.createElement("td", {
      className: "manage-permission-td-duration"
    }, "03:25 PM - 05:25 PM"), /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-dates-count"
    }, Number(leaveDays) > 1 ? "".concat(leaveDays, " Hours") : "".concat(leaveDays, " Hour")), /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-on"
    }, moment.unix(appliedAt / 1000).format("DD MMM, yyyy")), tabData == "approved" || tabData == "rejected" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "active-working",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", null, appliedStatus.charAt(0).toUpperCase() + appliedStatus.slice(1), " ", statusModifyDisplayName !== null ? "by ".concat(statusModifyDisplayName) : "", appliedStatus == "rejected" && leaveRejectReason ? /*#__PURE__*/React.createElement("div", null, "Rejection Reason : ", leaveRejectReason) : null))
    }, /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-card-table-all-by-text-all"
    }, statusModifyDisplayName !== null ? statusModifyDisplayName : "")) : null, tabData == "all" ? /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-card-table-all-by-text admin-view-leave-card-table-list-status-td-text admin-view-leave-card-table-list-status-td-text-".concat(appliedStatus)
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "active-working",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", null, appliedStatus == "pending" ? "Pending Approval" : appliedStatus.charAt(0).toUpperCase() + appliedStatus.slice(1), " ", statusModifyDisplayName !== null ? "by ".concat(statusModifyDisplayName) : "", appliedStatus == "rejected" && leaveRejectReason ? /*#__PURE__*/React.createElement("div", null, "Rejection Reason : ", leaveRejectReason) : null))
    }, /*#__PURE__*/React.createElement("span", null, appliedStatus == "pending" ? "Pending Approval" : appliedStatus.charAt(0).toUpperCase() + appliedStatus.slice(1), " ", statusModifyDisplayName !== null ? "by ".concat(statusModifyDisplayName) : ""))) : null, /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-listing-tab-Content-list-info"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      key: "active-working",
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, /*#__PURE__*/React.createElement("div", null, leaveReason))
    }, /*#__PURE__*/React.createElement("span", {
      className: "admin-view-listing-tab-tab-Content-list-dates-text"
    }, leaveReason))), tabData == "pending" ? /*#__PURE__*/React.createElement("td", {
      className: "admin-view-leave-card-table-list-status-td"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: approvedStatusCheck ? "success" : "outline-success",
      className: "rounded-pill admin-view-leave-reviewed-button",
      size: "sm",
      onClick: function onClick() {
        if (!approvedStatusCheckForDisable && !approvedStatusCheck) {
          handleChangeLeaveStatusShow({
            leaveId: leaveId,
            leaveStatus: "approved",
            userId: user.userId
          });
        }
      },
      disabled: approvedStatusCheckForDisable || approvedStatusCheck
    }, approvedStatusCheck ? "Approved" : "Approve"), /*#__PURE__*/React.createElement(Button, {
      variant: rejectedStatusCheck ? "danger" : "outline-danger",
      className: "rounded-pill admin-view-leave-reviewed-button",
      size: "sm",
      onClick: function onClick() {
        if (!rejectedStatusCheckForDisable && !rejectedStatusCheck) {
          handleChangeLeaveStatusShow({
            leaveId: leaveId,
            leaveStatus: "rejected",
            userId: user.userId
          });
        }
      },
      disabled: rejectedStatusCheckForDisable || rejectedStatusCheck
    }, rejectedStatusCheck ? "Rejected" : "Reject")) : tabData == "all" ? /*#__PURE__*/React.createElement("div", {
      className: "admin-view-listing-tab-tab-Content-table-data-icon-whole-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "admin-view-listing-tab-tab-Content-table-data-icon-div",
      onClick: function onClick() {
        return handleDeleteLeaveModalShow(list);
      }
    }, /*#__PURE__*/React.createElement(MdDeleteForever, {
      className: "admin-view-listing-tab-tab-Content-table-data-edit-icon"
    }), /*#__PURE__*/React.createElement("p", {
      className: "admin-view-listing-tab-tab-Content-table-data-edit-text"
    }, "Delete"))) : null));
  })))) : planName == "free" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-notext"
  }, "You have no leaves to show", " ", /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-notext-free-text"
  }, "On the free plan, you can access the last 14 days of data only. Upgrade to the Pro plan to get the historical data."))) : /*#__PURE__*/React.createElement("div", {
    className: "leave-listing-tab-tab-Content-notext"
  }, " ", tabData === "all" ? "You have no leaves to show" : "You have no ".concat(tabData, " leaves to show")), /*#__PURE__*/React.createElement(LeaveStatusChangeModal, {
    changeLeaveStatusModal: changeLeaveStatusModal,
    handleChangeLeaveStatusClose: handleChangeLeaveStatusClose,
    organisationId: organisationId,
    reviewedLeaveList: reviewedLeaveList,
    setReviewedLeaveList: setReviewedLeaveList,
    organisationTimezone: organisationTimezone,
    planName: planName,
    setReasonText: setReasonText,
    reasonText: reasonText
  }), /*#__PURE__*/React.createElement(DeleteConfirmation, {
    show: deleteLeaveModal,
    handleDeleteLeaveModalClose: handleDeleteLeaveModalClose,
    organisationTimezone: organisationTimezone,
    organisationId: organisationId,
    deleteLeaveData: deleteLeaveData,
    setDeleteLeaveData: setDeleteLeaveData,
    userParameterCheck: userParameterCheck,
    startDate: leavePeriodDate,
    last14Days: last14Days,
    organisationBilling: organisationBilling
  }));
};
var LeaveStatusChangeModal = function LeaveStatusChangeModal(props) {
  var changeLeaveStatusModal = props.changeLeaveStatusModal,
    handleChangeLeaveStatusClose = props.handleChangeLeaveStatusClose,
    organisationId = props.organisationId,
    reviewedLeaveList = props.reviewedLeaveList,
    setReviewedLeaveList = props.setReviewedLeaveList,
    organisationTimezone = props.organisationTimezone,
    planName = props.planName,
    setReasonText = props.setReasonText,
    reasonText = props.reasonText;
  if (changeLeaveStatusModal == null) {
    return false;
  }
  var leaveId = changeLeaveStatusModal.leaveId,
    leaveStatus = changeLeaveStatusModal.leaveStatus,
    userId = changeLeaveStatusModal.userId;
  var _useMutation = useMutation(UPDATE_LEAVE_STATUS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    updateLeaveStatus = _useMutation2[0],
    updateLeaveStatusLoading = _useMutation2[1].loading;
  var handleReview = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(leaveId, leaveStatus) {
      var leaveResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!updateLeaveStatusLoading) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            _context.next = 5;
            return updateLeaveStatus({
              variables: {
                organisationId: organisationId,
                leaveId: leaveId,
                leaveStatus: leaveStatus,
                timeZone: organisationTimezone,
                userId: userId,
                rejectedReasonText: leaveStatus !== "approved" && reasonText !== "" ? reasonText : null,
                freePlanStatus: planName
              }
            });
          case 5:
            leaveResponse = _context.sent;
            if (!leaveResponse || !leaveResponse.data || leaveResponse.data.updateLeaveStatus == null) {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              setReviewedLeaveList(function (oldLeave) {
                return [].concat(_toConsumableArray(oldLeave), [{
                  leaveId: leaveId,
                  leaveStatus: leaveStatus
                }]);
              });
              handleChangeLeaveStatusClose();
              toast.success("Leave ".concat(leaveStatus, " successfully!"));
              setReasonText("");
            }
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            console.log(_context.t0);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [updateLeaveStatus, updateLeaveStatusLoading, reasonText]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: changeLeaveStatusModal,
    onHide: handleChangeLeaveStatusClose,
    animation: false,
    size: "md",
    className: "add-holiday-import-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "add-holiday-import-modal-header-title"
  }, leaveStatus == "approved" ? "Approve Leave" : "Reject Leave")), leaveStatus == "approved" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "view-leave-list-status-approved-modal-body"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to ".concat(leaveStatus == "approved" ? "approve" : "reject", " this leave?")), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, leaveStatus == "approved" ? "You can't undo this action once you've approved this leave." : "You can't undo this action once you've rejected this leave.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleChangeLeaveStatusClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: leaveStatus == "approved" ? "success" : "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleReview(leaveId, leaveStatus);
    },
    disabled: updateLeaveStatusLoading ? true : false
  }, updateLeaveStatusLoading ? "Loading..." : leaveStatus == "approved" ? "Approve" : "Reject"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "view-leave-list-status-approved-modal-body"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to ".concat(leaveStatus == "approved" ? "approve" : "reject", " this leave?")), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, leaveStatus == "approved" ? "You can't undo this action once you've approved this leave." : "You can't undo this action once you've rejected this leave."), /*#__PURE__*/React.createElement(Form.Group, {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(ControlLabel, {
    className: "form-control-text-area-form-div-field-label-name "
  }, "Leave Rejection Reason (optional)"), /*#__PURE__*/React.createElement(Form.Control, {
    className: "textFeedback",
    as: "textarea",
    rows: "3",
    placeholder: "",
    value: reasonText,
    onChange: function onChange(e) {
      return setReasonText(e.target.value);
    },
    type: "text"
  }))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleChangeLeaveStatusClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: leaveStatus == "approved" ? "success" : "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleReview(leaveId, leaveStatus);
    }
    //type="submit"
    ,
    disabled: updateLeaveStatusLoading ? true : false
  }, updateLeaveStatusLoading ? "Loading..." : leaveStatus == "approved" ? "Approve" : "Reject"))));
};
var DeleteConfirmation = function DeleteConfirmation(props) {
  var show = props.show,
    handleDeleteLeaveModalClose = props.handleDeleteLeaveModalClose,
    setDeleteLeaveData = props.setDeleteLeaveData,
    deleteLeaveData = props.deleteLeaveData,
    organisationTimezone = props.organisationTimezone,
    organisationId = props.organisationId,
    userParameterCheck = props.userParameterCheck,
    startDate = props.startDate,
    last14Days = props.last14Days,
    organisationBilling = props.organisationBilling;
  if (show == null) {
    return null;
  }
  var currentYear = moment().format("YYYY");
  var userId = show.userId,
    dateDetails = show.dateDetails,
    leaveId = show.leaveId;
  var _useMutation3 = useMutation(DELETE_LEAVE_DETAILS_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    deleteLeave = _useMutation4[0],
    deleting = _useMutation4[1].loading;
  var onDeleteSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var tempDateDetails, variables, response, deleteUser;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!deleting) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            _context2.prev = 2;
            tempDateDetails = dateDetails.reduce(function (acc, curr) {
              acc.push({
                dayType: curr.dayType,
                date: curr.date,
                nonWorkingDayLeaveSession: curr.nonWorkingDayLeaveSession
              });
              return acc;
            }, []);
            variables = {
              userId: userId,
              dateDetails: tempDateDetails,
              leaveId: leaveId,
              organisationId: organisationId,
              timeZone: organisationTimezone,
              deleteLeaveType: "manageLeave",
              freePlanStatus: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName
            };
            _context2.next = 7;
            return deleteLeave({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_DETAILS_FOR_STATUS_COUNT_QUERY,
                variables: {
                  organisationId: organisationId,
                  userId: userParameterCheck && userParameterCheck.value ? userParameterCheck.value : null,
                  leavePeriod: startDate ? moment(startDate).format("x") : null,
                  timeZone: organisationTimezone,
                  freePlanStartDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[0] : null : null,
                  freePlanEndDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" ? last14Days ? last14Days[1] : null : null
                }
              }]
            });
          case 7:
            response = _context2.sent;
            if (response && response.data && response.data.deleteLeave !== "") {
              deleteUser = _toConsumableArray(deleteLeaveData);
              deleteUser.push(response.data.deleteLeave);
              setDeleteLeaveData(_toConsumableArray(deleteUser));
              handleDeleteLeaveModalClose();
              toast.success("Leave deleted successfully!");
            }
            _context2.next = 13;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](2);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 11]]);
    }));
    return function onDeleteSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    onHide: handleDeleteLeaveModalClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Leave")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, " ", /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to delete this leave?"), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, "You can't undo this action once you deleted this leave.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: function onClick() {
      return handleDeleteLeaveModalClose();
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      onDeleteSubmit();
    },
    disabled: deleting
  }, deleting ? "Loading..." : "Delete")));
};
export default ManagePermission;